import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

const myBoatsQuery = graphql(/* GraphQL */ `
  query myBoats {
    myBoats {
      boatId
      name
      slug
      currency
    }
  }
`);

const useGetPartnerBoats = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading, error } = useQuery<{
    myBoats: Array<{
      boatId: number;
      name: string;
      slug: string;
      currency: string;
    }>;
  }>({
    queryKey: ['partnerBoats'],
    queryFn: async () => {
      return graphqlRequest(myBoatsQuery, undefined, getAccessTokenSilently);
    },
    enabled: isAuthenticated,
    staleTime: 300000, // 5 minutes
    retry: shouldRetryQuery,
  });

  return {
    boats: data?.myBoats || [],
    isLoading,
    isError: !!error,
    error,
  };
};

export default useGetPartnerBoats;
